import { render, staticRenderFns } from "./Charities.vue?vue&type=template&id=cc81b510&scoped=true&"
import script from "./Charities.vue?vue&type=script&lang=js&"
export * from "./Charities.vue?vue&type=script&lang=js&"
import style0 from "./Charities.vue?vue&type=style&index=0&id=cc81b510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc81b510",
  null
  
)

export default component.exports